export default __webpack_public_path__ + "static/media/bed.cf0fe273.svg";